module.exports = __webpack_public_path__ + "static/img/netherlands.67a6d92.png";